(function () {
  var STORAGE_KEY = 'sh_nav_variant';
  var VALID = ['v2-wcf', 'v2-ren'];

  function resolveVariant() {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get('nav_variant');

    if (fromUrl === 'control') {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      return null;
    }

    if (fromUrl && VALID.indexOf(fromUrl) !== -1) {
      try {
        window.localStorage.setItem(STORAGE_KEY, fromUrl);
      } catch (e) {}
      return fromUrl;
    }

    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      if (VALID.indexOf(stored) !== -1) return stored;
    } catch (e) {}

    return null;
  }

  function applyVariant(variant) {
    if (!variant) return;

    var mapEl = document.querySelector('[data-sh-nav-variant-map]');
    if (!mapEl) return;

    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    var images = map[variant];
    if (!images) return;

    document.querySelectorAll('[data-sh-model-key]').forEach(function (mediaEl) {
      var key = mediaEl.getAttribute('data-sh-model-key');
      var url = images[key];
      if (!url) return;

      var img = mediaEl.querySelector('img');
      if (!img) return;

      img.src = url;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    });

    document.body.classList.add('sh-nav-variant--' + variant);
  }

  applyVariant(resolveVariant());
})();
